var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShipmentReturn = function SvgShipmentReturn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.906.5v3.327M11.313 7V3.827H.5v6.654a.83.83 0 0 0 .832.832H6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.5 3.827 1.248-2.404A1.66 1.66 0 0 1 3.195.5h5.423a1.66 1.66 0 0 1 1.489.923l1.206 2.404M8 10h3.75c.967 0 1.75.784 1.75 1.75v0a1.75 1.75 0 0 1-1.75 1.75H8.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.5 8 10l1.5-1.5"
  }))));
};
export default SvgShipmentReturn;